(() => {
  if (window.__eusariHeaderLoaded) return;
  window.__eusariHeaderLoaded = true;

  const cleanups = new Map();

  const init = (root) => {
    if (!root || cleanups.has(root)) return;
    const header = root.querySelector('.eusari-topbar');
    const utilityBar = root.querySelector('.eusari-utility-bar');
    const buttons = [...root.querySelectorAll('[data-utility-panel]')];
    const panels = [...root.querySelectorAll('.eusari-utility-panel')];
    const cartCounts = [...root.querySelectorAll('[data-header-cart-count], .cart-badge')];
    const buttonHandlers = [];
    const panelHandlers = [];
    const cartEvents = ['theme:cart:change', 'cart:updated', 'cartUpdated', 'cart:item-added', 'cart:changed', 'theme:cart:reload'];
    let activeTrigger = null;
    let cartCountRequest = null;

    const updateCartCount = (itemCount) => {
      const count = Number(itemCount);
      if (!cartCounts.length || !Number.isFinite(count)) return;

      const value = String(Math.max(0, count));
      cartCounts.forEach((cartCount) => {
        cartCount.dataset.headerCartCount = value;
        cartCount.textContent = value;
        cartCount.hidden = count === 0;
      });
    };
    const refreshCartCount = (event) => {
      const itemCount = event?.detail?.cart?.item_count;
      if (itemCount != null) {
        updateCartCount(itemCount);
        return;
      }

      if (cartCountRequest) return;
      cartCountRequest = fetch('/cart.js')
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => updateCartCount(cart?.item_count))
        .catch(() => {})
        .finally(() => { cartCountRequest = null; });
    };

    const close = ({ restoreFocus = false } = {}) => {
      const trigger = activeTrigger;
      const hadOpenPanel = panels.some((panel) => panel.classList.contains('eusari-is-open'));
      buttons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      panels.forEach((panel) => panel.classList.remove('eusari-is-open'));
      activeTrigger = null;
      if (restoreFocus && hadOpenPanel && trigger?.isConnected) trigger.focus();
    };
    buttons.forEach((button) => {
      const handler = (event) => {
        event.stopPropagation();
        const panel = root.querySelector(`#${CSS.escape(`${button.dataset.utilityPanel}-${root.dataset.sectionId}`)}`);
        const open = button.getAttribute('aria-expanded') !== 'true';
        close();
        if (open && panel) {
          button.setAttribute('aria-expanded', 'true');
          panel.classList.add('eusari-is-open');
          activeTrigger = button;
        }
      };
      buttonHandlers.push(handler);
      button.addEventListener('click', handler);
    });
    panels.forEach((panel) => {
      const handler = (event) => event.stopPropagation();
      panelHandlers.push(handler);
      panel.addEventListener('click', handler);
    });
    let lastY = window.scrollY;
    let frame = 0;
    const update = () => {
      const currentY = window.scrollY;
      const hidden = currentY > lastY && currentY > 96;
      header?.classList.toggle('eusari-is-scrolled', currentY > 8);
      header?.classList.toggle('eusari-is-hidden', hidden);
      utilityBar?.classList.toggle('eusari-is-hidden', hidden);
      lastY = currentY;
      frame = 0;
    };
    const onScroll = () => { if (!frame) frame = requestAnimationFrame(update); };
    const onKeyup = (event) => {
      if (event.key === 'Escape') close({ restoreFocus: true });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('click', close);
    document.addEventListener('keyup', onKeyup);
    cartEvents.forEach((eventName) => document.addEventListener(eventName, refreshCartCount));
    refreshCartCount();

    cleanups.set(root, () => {
      buttons.forEach((button, index) => button.removeEventListener('click', buttonHandlers[index]));
      panels.forEach((panel, index) => panel.removeEventListener('click', panelHandlers[index]));
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('click', close);
      document.removeEventListener('keyup', onKeyup);
      cartEvents.forEach((eventName) => document.removeEventListener(eventName, refreshCartCount));
      if (frame) cancelAnimationFrame(frame);
    });
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-eusari-section="header"]').forEach(init);
  const onLoad = (event) => initAll(event.target);
  const onUnload = (event) => {
    const root = event.target.querySelector('[data-eusari-section="header"]');
    cleanups.get(root)?.();
    cleanups.delete(root);
  };
  initAll();
  document.addEventListener('shopify:section:load', onLoad);
  document.addEventListener('shopify:section:unload', onUnload);
})();
